import { CollectionEntity } from '@busy-human/gearbox';
export var Destinations;
(function (Destinations) {
    let ProjectType;
    (function (ProjectType) {
        ProjectType["Education"] = "education";
        ProjectType["Community"] = "community";
        ProjectType["Healthcare"] = "healthcare";
        ProjectType["Religion"] = "religion";
        ProjectType["Family"] = "family";
        ProjectType["Leadership"] = "leadership";
    })(ProjectType = Destinations.ProjectType || (Destinations.ProjectType = {}));
    ;
    Destinations.DestinationTypeMap = {
        'education': "Education",
        'community': "Community",
        'healthcare': "Healthcare",
        'religion': "Religion",
        'family': "Family",
        'leadership': "Leadership"
    };
    let LocationType;
    (function (LocationType) {
        LocationType["Jungle"] = "jungle";
        LocationType["Island"] = "island";
        LocationType["Mediterranean"] = "mediterranean";
        LocationType["Savanna"] = "savanna";
        LocationType["Mountain"] = "mountain";
    })(LocationType = Destinations.LocationType || (Destinations.LocationType = {}));
    let SightseeingType;
    (function (SightseeingType) {
        SightseeingType["Wildlife"] = "wildlife";
        SightseeingType["History"] = "history";
        SightseeingType["Beach"] = "beach activities";
        SightseeingType["Ropes"] = "ropes";
        SightseeingType["Winter"] = "winter activities";
        SightseeingType["Hike"] = "hike";
        SightseeingType["Desert"] = "desert";
        SightseeingType["River"] = "river activities";
    })(SightseeingType = Destinations.SightseeingType || (Destinations.SightseeingType = {}));
    let Region;
    (function (Region) {
        Region["Africa"] = "Africa";
        Region["Asia"] = "Asia";
        Region["Caribbean"] = "Caribbean";
        Region["CentralAmerica"] = "Central America";
        Region["Mainland"] = "Mainland";
        Region["MiddleEast"] = "MiddleEast";
        Region["Oceania"] = "Oceania";
        Region["SouthAmerica"] = "South America";
    })(Region = Destinations.Region || (Destinations.Region = {}));
    let ClimateType;
    (function (ClimateType) {
        ClimateType["hotHumid"] = "Hot, Humid";
    })(ClimateType = Destinations.ClimateType || (Destinations.ClimateType = {}));
    let AdventureLevel;
    (function (AdventureLevel) {
        AdventureLevel["easy"] = "Easy";
        AdventureLevel["moderate"] = "Moderate";
        AdventureLevel["difficult"] = "Difficult";
        AdventureLevel["challenging"] = "Challenging";
    })(AdventureLevel = Destinations.AdventureLevel || (Destinations.AdventureLevel = {}));
    let DestinationLocation;
    (function (DestinationLocation) {
        DestinationLocation["Mainland"] = "Mainland";
        DestinationLocation["International"] = "International";
    })(DestinationLocation = Destinations.DestinationLocation || (Destinations.DestinationLocation = {}));
    Destinations.NonPeak15Properties = ["ageRange", "thumbnailImage", "bannerImage", "IgPosts"];
    function Default() {
        return {
            name: '',
            displayName: '',
            description: '',
            project: {
                // type: [],
                description: '',
                city: '',
                story: ''
            },
            destinationLocation: DestinationLocation.Mainland,
            destinationType: "",
            maxGuests: 0,
            price: -1,
            season: "2023 Season",
            medicalReqs: "",
            snapshot: "",
            location: '',
            locationType: [],
            region: null,
            // sightseeing: [],
            climate: '',
            passportRequired: true,
            vaccineRequired: true, //Not sure if the defaults here really matter but I think it would be best if default to restrictions for the worst case
            visaRequired: false,
            adventureLevel: AdventureLevel.easy
        };
    }
    Destinations.Default = Default;
    /** Returns true if the destination is domestic/inside the US */
    function IsDestinationDomestic(destination) {
        return !destination.isInternational;
    }
    Destinations.IsDestinationDomestic = IsDestinationDomestic;
    Destinations.DEST_AGE_MINIMUM_DOMESTIC = 14;
    Destinations.DEST_AGE_MAXIMUM_DOMESTIC = 16;
    Destinations.DEST_AGE_MINIMUM_INTERNATIONAL = 16;
    Destinations.DEST_AGE_MAXIMUM_INTERNATIONAL = 19;
    /** Returns the minimum age for a destination */
    function GetDestinationMinimumAge(destination) {
        return IsDestinationDomestic(destination) ? Destinations.DEST_AGE_MINIMUM_DOMESTIC : Destinations.DEST_AGE_MINIMUM_INTERNATIONAL;
    }
    Destinations.GetDestinationMinimumAge = GetDestinationMinimumAge;
    /** Maximum age for a destination (returns 21 if international) */
    function GetDestinationMaximumAge(destination) {
        return IsDestinationDomestic(destination) ? Destinations.DEST_AGE_MAXIMUM_DOMESTIC : Destinations.DEST_AGE_MAXIMUM_INTERNATIONAL;
    }
    Destinations.GetDestinationMaximumAge = GetDestinationMaximumAge;
    class CollectionClass extends CollectionEntity {
        relationships = {};
        defaults() {
            return Default();
        }
        async getAllAsMap() {
            return new Map((await this.fetchAll()).dataItems().map(b => ([b.$id, b])));
        }
    }
    Destinations.CollectionClass = CollectionClass;
    Destinations.Collection = new CollectionClass({ path: "/Destinations" });
    /** @deprecated */
    Destinations.OldCollection = new CollectionClass({ path: "/Trips" });
})(Destinations || (Destinations = {}));
// export { Destinations as Trips };
//# sourceMappingURL=index.js.map